import * as THREE from 'three';
import Experience from '../Experience.js';
import { gsap } from 'gsap';

export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;
        this.loadingScreen = this.experience.loadingScreen;

        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Environment');
            this.debugFolder.close();
        }

        this.setSunLight();
        this.setEnvironmentMap();

        // TODO: タイミングなどは最後に調整する
        // 環境の光
        gsap.delayedCall(5.0, () => {
            // 解決策1：ダミーオブジェクトを使用
            const lightParams = {
                sunIntensity: 0,
                envIntensity: 0
            };

            gsap.to(lightParams, {
                duration: 3.0,
                sunIntensity: 4.0,
                envIntensity: 0.5,
                ease: "power2.in",
                onUpdate: () => {
                    // 毎フレーム実際の値を更新
                    this.sunLight.intensity = lightParams.sunIntensity;
                    this.environmentMap.intensity = lightParams.envIntensity;
                    // 🔥 重要：EnvironmentMap の変更時は updateMaterial を呼ぶ
                    this.environmentMap.updateMaterial();
                },
                onComplete: () => {
                    console.log('Light animation completed!');
                    console.log('SunLight intensity:', this.sunLight.intensity);
                    console.log('EnvironmentMap intensity:', this.environmentMap.intensity);
                }
            });
        });
    }

    setSunLight() {
        // 初期値は0
        this.sunLight = new THREE.DirectionalLight('#ffffff', 0)
        this.sunLight.castShadow = true
        this.sunLight.shadow.camera.far = 15
        this.sunLight.shadow.mapSize.set(1024, 1024)
        this.sunLight.shadow.normalBias = 0.05
        this.sunLight.position.set(3.5, 2, -1.25)
        this.scene.add(this.sunLight)

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .add(this.sunLight, 'intensity')
                .name('sunLightIntensity')
                .min(0)
                .max(10)
                .step(0.001)

            this.debugFolder
                .add(this.sunLight.position, 'x')
                .name('sunLightPosX')
                .min(-5)
                .max(5)
                .step(0.001)

            this.debugFolder
                .add(this.sunLight.position, 'y')
                .name('sunLightPosY')
                .min(-5)
                .max(5)
                .step(0.001)

            this.debugFolder
                .add(this.sunLight.position, 'z')
                .name('sunLightPosZ')
                .min(-5)
                .max(5)
                .step(0.001)
        }
    }

    setEnvironmentMap() {
        this.environmentMap = {};
        // 初期値は0で、その後0.5にする
        this.environmentMap.intensity = 0;
        this.environmentMap.texture = this.resources.items.environmentMapTexture;
        this.environmentMap.texture.colorSpace = THREE.SRGBColorSpace;

        this.scene.environment = this.environmentMap.texture;

        this.environmentMap.updateMaterial = () => {
            this.scene.traverse((child) => {
                if (!(child instanceof THREE.Mesh)) return;

                // Book のページのようにマテリアルが配列のメッシュも対象にする
                const materials = Array.isArray(child.material) ? child.material : [child.material];
                materials.forEach((material) => {
                    if (material instanceof THREE.MeshStandardMaterial) {
                        material.envMap = this.environmentMap.texture;
                        material.envMapIntensity = this.environmentMap.intensity;
                        material.needsUpdate = true;
                    }
                });
            });
        }
        this.environmentMap.updateMaterial();

        // Debug
        if (this.debug.active) {
            this.debugFolder
                .add(this.environmentMap, 'intensity')
                .name('environmentMapIntensity')
                .min(0)
                .max(1)
                .step(0.001)
                .onChange(() => {
                    this.environmentMap.updateMaterial();
                });
        }
    }
}